import { CircleAlert } from 'lucide-react';
import type { ChangeEvent, ReactNode } from 'react';
import { FieldFeedback, FieldLabel } from '../Form/FieldLabel';

interface PackageNameFieldBaseProps {
  value: string;
  disabled?: boolean;
  required?: boolean;
  error?: string | null;
  showError?: boolean;
  description?: string;
  inputClassName: string;
  afterInput?: ReactNode;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function PackageNameFieldBase({
  value,
  disabled,
  required,
  error,
  showError,
  description = 'Android package name in reverse domain format (e.g., com.example.app).',
  inputClassName,
  afterInput,
  onChange,
}: PackageNameFieldBaseProps) {
  return (
    <div>
      <FieldLabel
        label="Package Name"
        required={required}
        explanation={description}
      />
      <div className="relative mt-1">
        <input
          type="text"
          name="packageName"
          aria-label="Package Name"
          value={value}
          onChange={onChange}
          placeholder="com.example.app"
          required={required}
          disabled={disabled}
          className={inputClassName}
        />
        {afterInput}
      </div>
      {error && showError && (
        <FieldFeedback className="mt-1">
          <CircleAlert aria-hidden="true" />
          <span>{error}</span>
        </FieldFeedback>
      )}
    </div>
  );
}
